import { DateInput, TextInput } from '@core/components/Inputs';
import { Grid } from '@material-ui/core';
import { PessoaFisicaAutocomplete } from 'app/main/pessoa';
import React,{ useEffect, useState } from 'react';

const ClienteDadosGeraisPessoaFisica = ({
  id,
  name,
  values = {},
  errors = {},
  touched = {},
  onChange,
  onBlur,
  fetchPapel,
  possuiVinculo,
}) => {
  const { pessoaFisica = {}, inscricaoMunicipal } = values;

  const _errors = errors?.pessoaFisica || {};
  const _touched = touched?.pessoaFisica || {};

  const [desabilitarCPF, setDesabilitarCPF] = useState(false);

  useEffect(() => {
    if (possuiVinculo && pessoaFisica?.cpf) {
      setDesabilitarCPF(true);
    }
    // Efeito reativo apenas ao gatilho acima; incluir as demais reiniciaria o formulário durante a edição.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [possuiVinculo]);

  return (
    <>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <PessoaFisicaAutocomplete
          id={`${id}.cpf`}
          name={`${name}.cpf`}
          value={pessoaFisica?.cpf}
          error={_errors?.cpf}
          touched={_touched}
          onBlur={onBlur}
          onChange={onChange}
          papel="cliente"
          fetchPapel={fetchPapel}
          disabled={desabilitarCPF}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <TextInput
          id={`${id}.identidade`}
          name={`${name}.identidade`}
          onChange={onChange}
          onBlur={onBlur}
          value={pessoaFisica.identidade}
          error={_errors.identidade}
          touched={_touched.identidade}
          fullWidth
          maxLength={10}
          variant="outlined"
          label="Identidade"
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <DateInput
          fullWidth
          disableFuture
          id={`${id}.dataNascimento`}
          name={`${name}.dataNascimento`}
          label="Data de nascimento"
          value={pessoaFisica.dataNascimento}
          onChange={onChange}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <TextInput
          id="pessoa.inscricaoMunicipal"
          name="pessoa.inscricaoMunicipal"
          onChange={onChange}
          onBlur={onBlur}
          value={inscricaoMunicipal}
          error={errors.inscricaoMunicipal}
          touched={touched.inscricaoMunicipal}
          fullWidth
          variant="outlined"
          label="Inscrição municipal"
          maxLength={20}
        />
      </Grid>
    </>
  );
};

export default ClienteDadosGeraisPessoaFisica;
